class ObjectDeleteError extends Error {
    constructor(messages) {
        super(null);

        this.messages = messages;
    }

    getMessages() {
        return this.messages;
    }
}

export default ObjectDeleteError;
